import { render, staticRenderFns } from "./Input-select.vue?vue&type=template&id=574decb2&scoped=true"
import script from "./Input-select.vue?vue&type=script&lang=ts"
export * from "./Input-select.vue?vue&type=script&lang=ts"
import style0 from "./Input-select.vue?vue&type=style&index=0&id=574decb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574decb2",
  null
  
)

export default component.exports